import Card from '@/components/Card';
import DefaultContentTemplateTags from '@/components/DefaultContentTemplate/Tags';
import Slider from '@/components/Slider';
import { ResourceEntity } from '@/graphql/generated/graphql';
import useIsMobile from '@/hooks/useIsMobile';
import { useKnowledgeHubStore } from '@/pages/knowledge-hub/page/store/useKnowledgeHubStore';
import { getAuthors } from '@/services/knowledge-hub/utils';
import { Loading } from './loading';
import { useEffect } from 'react';

export default function TrendingThisWeek() {
  const { trendingResources, trendingResourcesLoading, loadTrendingResources } = useKnowledgeHubStore();
  const { isMobile } = useIsMobile();

  useEffect(() => {
    loadTrendingResources();
  }, [loadTrendingResources]);

  const renderContent = () => {
    return trendingResources?.map((resource: ResourceEntity) => {
      return (
        <Card
          key={resource.id}
          title={resource.attributes?.title || ''}
          description={resource.attributes?.briefDescription || ''}
          author={getAuthors(resource)}
          link={`/knowledge-hub/slug/${resource.attributes?.slug}`}
          tags={
            <DefaultContentTemplateTags
              tags={[resource?.attributes?.resourceType?.data?.attributes?.type?.toString() || '']}
              className="!mb-2 !mt-0"
              duration={resource?.attributes?.duration || undefined}
            />
          }
          image={{
            url: resource.attributes?.cover.data?.attributes?.url || '',
            alternativeText: resource.attributes?.cover.data?.attributes?.alternativeText || '',
          }}
        />
      );
    });
  };

  if (trendingResourcesLoading) {
    return <Loading />;
  }

  if (!isMobile) {
    return renderContent();
  }

  return (
    <>
      <Slider
        disableResponsiveDots={true}
        slideClassName="!max-h-none"
        sliders={renderContent()}
        options={{
          disabled: true,
          breakpoints: {
            '(max-width: 768px)': {
              disabled: false,
              loop: true,
              renderMode: 'performance',
              slides: { perView: 1, spacing: 16 },
            },
          },
        }}
      />
    </>
  );
}
